import { render, staticRenderFns } from "./ShipTo.vue?vue&type=template&id=5707e12d&scoped=true"
import script from "./ShipTo.vue?vue&type=script&lang=ts"
export * from "./ShipTo.vue?vue&type=script&lang=ts"
import style0 from "./ShipTo.vue?vue&type=style&index=0&id=5707e12d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707e12d",
  null
  
)

export default component.exports